
import { jsonTransUrl } from './validator'
import router from '@/router/index'
import bridge from './bridge/wy-bridge'

// 解析url查询参数的工具方法
// export const getParam = name => {
//   const getValue = function (name, str) {
//     const reg = new RegExp('(^|!|&|\\?)' + name + '=([^&]*)(&|$)')
//     const r = str.match(reg)

//     if (r != null) {
//       try {
//         return decodeURIComponent(r[2])
//       } catch (e) {
//         console.log(e + 'r[2]:' + r[2])
//         return null
//       }
//     }
//     return null
//   }
//   let str = location.hash.substr(2)
//   let value = getValue(name, str)

//   if (value == null) {
//     str = location.search.substr(1)
//     value = getValue(name, str)
//   }
//   return value
// }

// 跳转 H5 聚合页
export const goH5Aggregate = (targetUrl) => {
  router.push(targetUrl)
}

// 能诚 App 中打开小程序
export const openAppletInApp = async (originalId, path = '') => {
  let params = {
    platform: 'weixin',
    type: 0,
    originId: originalId,
    path
  }

  bridge.emit('launchMiniProgram', params)
}

// 粤享5G App 中打开小程序
export const gdyx5GJumpMiniProgram = async (originalId, path = '') => {
  // console.log('粤享5G App 中打开小程序: ', path)
  const { jumpMiniProgram } = require('@/utils/gdzlyx-bridge')
  await jumpMiniProgram(originalId, path)
}

/**
 * 打开 小程序（只支持后端对接过的小程序，配置在商户里面） 【默认ydjk 一敦健康】 【wykj 微医科技】
 * openApplet('wykj', '/xxx/xx', { channel: 'qqq' })
 * openApplet('wykj', '/xxx/xx?channel=qqq')
 * miniPath 地址不允许携带参数，参数全都放在exParam 里面【字符串格式aa=11&bb=22&cc=33  对象{aa:11}】
 * 后台配置短链也需要注意：小程序的地址后面不能带参数
 */
export const openApplet = function (type = 'ydjk', miniPath = '', exParam = {}) {
  const appletMap = {
    ydjk: { originalId: 'gh_6f8f718b68d1', miniAppId: 'wxaef97c6ebdb38ee6', indexPath: '/pages/middle/index' }, // 一敦健康
    wykj: { originalId: 'gh_1177b0324325', miniAppId: 'wx6614f8744262e988', indexPath: '/pages/middle/index' }, // 微医科技
   zhibo: { originalId: 'gh_138c219fb18c', miniAppId: 'wx6259cbdc3a728e79', indexPath: '' }, // 医生直播
    jkrl: { originalId: 'gh_40818f329dba', miniAppId: 'wxd8cafd9679001a38', indexPath: '' } // 健康日历
  }
  const { originalId, miniAppId, indexPath } = appletMap[type]

  const { isNChApp, isIOS, isYX5G } = getUA()
  let path = miniPath || indexPath
  const _path = decodeURIComponent(path) === path ? encodeURIComponent(path) : path

  let _exParam
  // let _exParam = typeof exParam === 'string' ? encodeURIComponent(exParam) : encodeURIComponent(jsonTransUrl(exParam)) // aa=11&bb=22&cc=33
  if (typeof exParam === 'string') {
    _exParam = exParam
  }
  if (typeof exParam === 'object') {
    _exParam = jsonTransUrl(exParam)
  }
  if (_exParam) {
    if (!_exParam.includes('targetUrl=')) {
      _exParam = _exParam + (_path ? ('&targetUrl=' + _path) : '')
    }
  } else {
    _exParam = _path ? ('targetUrl=' + _path) : ''
  }
  // console.log('携带参数 111: ', _exParam)
  if (path && _exParam) {
    path = path + '?' + _exParam
  }
  if (_exParam) {
    _exParam = encodeURIComponent(_exParam)
  }
  // console.log('携带参数 222: ', _exParam)

  if (isNChApp) {
    openAppletInApp(originalId, path)
  } else if (isYX5G && isIOS) {
    gdyx5GJumpMiniProgram(originalId, path)
  } else if (type === 'ydjk') {
    // 小程序跳转 目前后端只对接了 merchantCode 【科技商户 platform  一敦健康商户 yidunhealthy】
    const url = `/#/entrance/shortChain?type=applet_ydjk&merchantCode=yidunhealthy&exParam=${_exParam}`
    window.location.href = url
  } else if (type === 'wykj') {
    const url = `/#/entrance/shortChain?type=applet_wykj&merchantCode=platform&exParam=${_exParam}`
    window.location.href = url
  } else {
    // 集团的方案
    const url = `https://wy.guahao.com/ums/mpjump?originalId=${originalId}&miniAppId=${miniAppId}&miniPath=${_path}`
    window.location.href = url
  }
}

// 获取 ua 以及判断是否处于 App 环境
export const getUA = (userAgent) => {
  const ua = (userAgent || (typeof navigator === 'undefined' ? '' : navigator.userAgent)).toLowerCase()
  const isAndroid = /android|adr/gi.test(ua)
  const isIOS = /iphone|ipod|ipad/gi.test(ua) && !isAndroid
  const isIPhone = /iphone/gi.test(ua) && !isAndroid
  const isNChApp = /NengChengBrowser/gi.test(ua) // 能诚App
  // isIOS的UA:  mozilla/5.0 (iphone; cpu iphone os 17_0_3 like mac os x) applewebkit/605.1.15 (khtml, like gecko) mobile/15e148wvjb 6.0.3 nengchengbrowser/1.0
  const isMiniProgram = /miniProgram/gi.test(ua) // 微信小程序
  const isWeChat = /micromessenger/gi.test(ua) // 微信浏览器【windowswechat 电脑版微信浏览器】
  const isYX5G = /yx5g/gi.test(ua) // 广东粤享5G App

  const isSXHSH_Android = isAndroid && ua.includes('5glife_') // 陕西和生活安卓端 5glife_android
  const isSXHSH_IOS = isIOS && ua.includes('ios-' + get_SXHSH_IOS_version(ua) + '-') // 陕西和生活ios端
  const isSXHSH = isSXHSH_Android || isSXHSH_IOS // 陕西和生活

  const isHjqApp = /hjqapp/gi.test(ua)
  // mozilla/5.0 (iphone; cpu iphone os 15_6 like mac os x) applewebkit/605.1.15 (khtml, like gecko) version/15.6 mobile/15e148 safari/604.1
  const isSafari = /safari/gi.test(ua)

  return {
    ua,
    isNChApp,
    isSafari,
    isMiniProgram,
    isAndroid,
    isIOS,
    isIPhone,
    isWeChat,
    isYX5G,
    isSXHSH_Android,
    isSXHSH_IOS,
    isSXHSH,
    isHjqApp
  }
}

const get_SXHSH_IOS_version = (ua) => {
  var version = null
  if (ua.indexOf('like mac os x') > 0) {
    var reg = /os [\d._]+/gi
    var v_info = ua.match(reg)
    version = (v_info + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.') // 得到版本号9.3.2或者9.0
    // version = parseInt(version.split('.')[0]) // 得到版本号第一位
  }
  return version
}



// WEBPACK FOOTER //
// ./src/utils/index.js